<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/myAccountList/">My Accounts</a></li>
      <li aria-current="page" class="breadcrumb-item active">Edit Address</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Address</h2>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group mt-3">
                <label class="control-label">Address Type : {{addressT}} </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group required">
                <label class="control-label" for="address1">Address1</label>
                <input (blur)="typeAddress()" [(ngModel)]="address.address1"
                       [ngClass]="{'is-invalid':address1ErrorMessage}" [ngModelOptions]="{standalone: true}"
                       class="form-control" id="address1"
                       required type="text">
                <div [hidden]="!address1ErrorMessage" class="invalid-feedback d-block shift-invalid-login">
                  {{address1ErrorMessage}}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="control-label" for="address2">Address2</label>
                <input [(ngModel)]="address.address2" [ngModelOptions]="{standalone: true}" class="form-control"
                       id="address2"
                       required type="text">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group required">
                <label class="control-label">City</label>
                <ng-select (blur)="typeCity()" [(ngModel)]="address.city" [ngClass]="{'is-invalid':cityErrorMessage}"
                           [ngModelOptions]="{standalone: true}" placeholder="City"
                           id="city" required [items]="citiesList" [addTag]="true"
                           type="text"></ng-select>
                <div [hidden]="!cityErrorMessage" class="invalid-feedback d-block shift-invalid-login">
                  {{cityErrorMessage}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group required">
                <label class="control-label">State</label>
                <ng-select (blur)="typeState()" [(ngModel)]="address.state" [items]="statesList"
                           [ngClass]="{'is-invalid':stateErrorMessage}"
                           [ngClass]="{'service-error':stateErrorMessage}"
                           [ngModelOptions]="{standalone: true}"
                           id="State"
                           placeholder="State">
                </ng-select>
                <div [hidden]="!stateErrorMessage" class="invalid-feedback d-block shift-invalid-login">
                  {{stateErrorMessage}}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group required">
                <label class="control-label" for="accountZipAlt">Zip</label>
                <input (blur)="typeZip()" [(ngModel)]="address.zip" [ngClass]="{'is-invalid':zipErrorMessage}"
                       (change)="ChangeCityAndState()" placeholder="Enter PinCode"
                       [ngModelOptions]="{standalone: true}" class="form-control" id="accountZipAlt" maxlength="6"
                       onkeypress='return event.charCode >= 48 && event.charCode <= 57' required type="text">
                <div [hidden]="!zipErrorMessage" class="invalid-feedback d-block shift-invalid-login">
                  {{zipErrorMessage}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button class="btn btn-cancel" routerLink="/admin/myAccountList" type="reset">Cancel</button>
      <button (click)="editAddress()" class="btn btn-orange ml-2" type="submit">Save</button>
    </div>
  </div>
</div>
